export const SECURE_REDIRECT_PARAM = 'redirectResult';

export const HANDLER_ID_PARAM = 'handlerId';

export const RESULT_CODES = {
	REFUSED: 'Refused',
	AUTHORIZED: 'Authorised'
};

export const REFULSAL_STATUS_CODES_MAP = {
	6: 'expiredCard',
	10: 'notSupported',
	12: 'notEnoughBalance',
	24: 'incorrectCVC',
	generic: 'refused'
};

export const EXTRA_ERRORS_MAP = {
	generic: 'generic'
};
